import type { APISharedProfileResponse } from '@see-stella/types'
import { labelForMetric } from './labels'
import { metricColorVar } from './model'
import './MetricDefinition.css'

interface MetricDefinitionProps {
  profile: APISharedProfileResponse
  techName: string
}

/**
 * The definition of the currently-selected metric, shown right beside the player
 * so the provider reads "this is redness, here's their redness, here's what
 * redness means" without leaving the view. Measurements-only: what it is + how
 * Stella measures it (no "improves/worsens with" guidance).
 */
export function MetricDefinition({ profile, techName }: MetricDefinitionProps) {
  const def = profile.definitions.find((d) => d.techName === techName)
  if (!def) return null
  return (
    <section
      className='mdef'
      style={{ '--dot-color': metricColorVar(techName) } as React.CSSProperties}
    >
      <div className='mdef__head'>
        <span className='mdef__sw' aria-hidden='true' />
        <h2 className='mdef__title'>{labelForMetric(techName)}</h2>
      </div>
      {def.whatIsIt && <p className='mdef__what'>{def.whatIsIt}</p>}
      {def.howWeMeasure.length > 0 && (
        <div className='mdef__how'>
          <div className='mdef__dl'>How Stella measures it</div>
          <ul className='mdef__list'>
            {def.howWeMeasure.map((x, i) => (
              <li key={i}>{x}</li>
            ))}
          </ul>
        </div>
      )}
    </section>
  )
}
